import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';

const AttendeeTable = ({
  attendeeTiers,
  currency
}) => {
  return (
    <div>
      {
        attendeeTiers.map((tier, i) => {
          const key = `${tier.value}-${i}`;
          const panelBody = classnames('flex middle calendar-price-panel-body',
            { 'border-bottom': attendeeTiers.length - 1 !== i });

          return (
            <div key={key} className={panelBody}>
              <div className="flex-basis-50">
                <div>
                  {tier.min} - {tier.max}
                </div>
              </div>
              <div className="flex-basis-50 text-right">
                <FormattedNumber
                  value={tier.value}
                  currency={currency}
                  style="currency"
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                />
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

AttendeeTable.propTypes = {
  attendeeTiers: PropTypes.array,
  currency: PropTypes.string
};

export default AttendeeTable;
